import {
 INQUIRY_SHIPPER_ALL_BIDS_INQUIRY_SET_FILTERS,
 INQUIRY_SHIPPER_ALL_BIDS_INQUIRY_APPLY_FILTERS,
 INQUIRY_SHIPPER_GET_ALL_BIDS_DATA_ENABLE_LOADING,
 INQUIRY_SHIPPER_GET_ALL_BIDS_DATA_DISABLE_LOADING,
 INQUIRY_SHIPPER_GET_ALL_BIDS_INQUIRY,
 INQUIRY_SHIPPER_ALL_BIDS_INQUIRY_SET_PAGINATION,
 INQUIRY_SHIPPER_GET_ALL_BIDS_INQUIRY_FETCH_ERROR,
 INQUIRY_SHIPPER_ALL_BIDS_INQUIRY_RESET_FILTERS,
 INQUIRY_SHIPPER_ALL_BIDS_INQUIRY_RESET_PAGINATION,
} from 'src/actions/constants';

const defaultState = {
  isSearching : false,
  selectedFilters: {
    sortBy: 'rank',
    descendingOrder: false,
  },
  appliedFilters: {
    sortBy: 'rank',
    descendingOrder: false,
  },
  pagination: {
    currentPageNumber: 1,
    resultPerPage: 10,
    nextOrPrev: 'first',
    isNextPresent: false,
  },
  isLoading: false,
  allBidsForInquiry :[],
  allBidsForInquiryError : '',
  inquiryBookingStats: undefined,
};
export default function (state: any = defaultState, action) {
  switch (action.type) {
    case INQUIRY_SHIPPER_GET_ALL_BIDS_INQUIRY: {
      return {
        ...state,
        allBidsForInquiry : action.data ? action.data.data : [],
        inquiryBookingStats: action.data?.inquiryBookingStats,
        pagination: {
          currentPageNumber : action.data && action.data.currentPageNumber,
          isNextPresent: action.data && action.data.isNextPresent,
          lastItemIdNext: action.data && action.data.lastItemIdNext,
          lastItemIdPrev: action.data && action.data.lastItemIdPrev,
          lastSortedColumnValueNext: action.data && action.data.lastSortedColumnValueNext,
          lastSortedColumnValuePrev: action.data && action.data.lastSortedColumnValuePrev,
        },
      };
    }
    case INQUIRY_SHIPPER_ALL_BIDS_INQUIRY_SET_PAGINATION: {
      return {
        ...state,
        pagination: {
          ...state.pagination,
          ...action.data,
        },
      };
    }
    case INQUIRY_SHIPPER_ALL_BIDS_INQUIRY_SET_FILTERS: {
      return {
        ...state,
        selectedFilters: {
          ...state.selectedFilters,
          ...action.data,
        },
      };
    }

    case INQUIRY_SHIPPER_ALL_BIDS_INQUIRY_APPLY_FILTERS: {
      return {
        ...state,
        appliedFilters: {
          ...state.appliedFilters,
          ...state.selectedFilters,
        },
      };
    }
    case INQUIRY_SHIPPER_ALL_BIDS_INQUIRY_RESET_FILTERS: {
      return {
        ...state,
        appliedFilters: defaultState.appliedFilters,
        selectedFilters: defaultState.selectedFilters,
      };
    }

    case INQUIRY_SHIPPER_ALL_BIDS_INQUIRY_RESET_PAGINATION: {
      return {
        ...state,
        pagination: defaultState.pagination,
      };
    }

    case INQUIRY_SHIPPER_GET_ALL_BIDS_DATA_ENABLE_LOADING: {
      return {
        ...state,
        isLoading: true,
      };
    }
    case INQUIRY_SHIPPER_GET_ALL_BIDS_DATA_DISABLE_LOADING: {
      return {
        ...state,
        isLoading: false,
      };
    }
    case INQUIRY_SHIPPER_GET_ALL_BIDS_INQUIRY_FETCH_ERROR: {
      return {
        ...state,
        allBidsForInquiryError : action.data,
      };
    }
    default: return state;
  }
}
